module.exports = __webpack_public_path__ + "static/img/egg_b_17.1888958.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_17.png
// module id = Y7M+
// module chunks = 1